import axios from 'axios';
import {
  INVOICES_URL,
  RECEIPT_INVOICES_URL,
  RECORD_PAYMENT_URL,
  RESEND_EMAIL_URL,
  PRINT_RECEIPT_INVOICE_PDF,
  EXPORT_INVOICES,
} from './constants';

/**
 * Get invoices.
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/reports_controller.rb#L74
 * @param startDate, endDate, page, perPage
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
export function getInvoices(queryparams) {
  return axios
    .get(INVOICES_URL, { params: queryparams, withCredentials: true })
    .catch(error => {
      return Promise.reject(new Error(error.message));
    });
}

/**
 * Get receipt invoices.
 * @param ID invoice
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
export function getReceiptInvoices(id, queryparams) {
  return axios
    .get(RECEIPT_INVOICES_URL(id), {
      params: queryparams,
      withCredentials: true,
    })
    .catch(error => {
      return Promise.reject(new Error(error.message));
    });
}

/**
 * Post record payment data to the server
 * @param id, paymentRecord
 */
export function createRecordPayment(data, outletId) {
  return axios
    .post(RECORD_PAYMENT_URL, data, {
      headers: { OUTLET_ID: outletId },
      withCredentials: true,
    })
    .catch(error => {
      return Promise.reject(new Error(error.message));
    });
}

// Resend receipt to customer email
export function resendEmail(invoiceId) {
  return axios
    .post(RESEND_EMAIL_URL(invoiceId), {}, { withCredentials: true })
    .catch(error => {
      return Promise.reject(new Error(error.message));
    });
}

// Open generated receipt invoice pdf
export function printReceiptInvoicePdf(invoiceId) {
  return window.open(PRINT_RECEIPT_INVOICE_PDF(invoiceId));
}

export function exportInvoices(query) {
  return axios
    .get(EXPORT_INVOICES, { params: query, withCredentials: true })
    .catch(error => {
      if (error.response) {
        const eobj = new Error(error.response.errors);
        return Promise.reject(eobj);
      }
      return Promise.reject(error);
    });
}
